export enum EnvironmentEnum {
    LOCAL = 'LOCAL',
    HOMOLOGACAO = 'HOMOLOGACAO',
    DEVELOPMENT = 'DEVELOPMENT',
    PRODUCTION  = 'PRODUCTION',
}
